import http from '@/utils/http';
import { expiredStorage } from '@/utils/expiredStorage';
class ChatApi {
    getDefaultContext() {
        // 取 userId
        try {
            // 检测是否为无痕模式
            const isIncognito = this.isIncognitoModeSync();
            if (isIncognito) {
                console.log('无痕模式检测到，清除数据并返回空上下文');
                // 清除所有相关数据
                localStorage.removeItem('agent-form-step4');
                localStorage.removeItem('agent-form-step1');
                localStorage.removeItem('agent-form-step2');
                localStorage.removeItem('agent-form-step3');
                return {};
            }
            const obj = expiredStorage.getItem('agent-form-step4');
            if (!obj)
                return {};
            // API调用成功，重置Step4数据的过期时间
            if (expiredStorage.hasItem('agent-form-step4')) {
                expiredStorage.resetExpireTime('agent-form-step4', 30);
                console.log('聊天API调用成功，已重置Step4数据过期时间为30分钟');
            }
            return { userid: obj.payload.userId, face_image_url: (process.env.VUE_APP_PROXY_CREATE || 'http://test2.o3.xyz') + obj.image_url };
        }
        catch (_) {
            return {};
        }
    }
    isIncognitoModeSync() {
        try {
            // 检测 indexedDB 是否可用
            if (!window.indexedDB) {
                return true;
            }
            // 检测 localStorage 配额
            const testKey = '__incognito_test__';
            localStorage.setItem(testKey, 'test');
            localStorage.removeItem(testKey);
            // 检测 navigator.webdriver
            if (navigator.webdriver) {
                return true;
            }
            // 检测插件数量
            if (navigator.plugins && navigator.plugins.length === 0) {
                return true;
            }
            return false;
        }
        catch (e) {
            return true;
        }
    }
    /**
     * 发送聊天消息
     */
    async sendMessage(message) {
        try {
            // 注入默认 user_id 与 face_image_url（若调用方未显式传入）
            // const { userid, face_image_url } = this.getDefaultContext()
            const { userId, face_image_url } = expiredStorage.getItem('user');
            const merged = {
                user_id: userId,
                face_image_url: face_image_url,
                ...message,
                // text: "开始造型",
            };
            console.log('发送聊天消息:', merged);
            // 统一走 /api 代理，chat 直连 /chat
            const response = await http.post('/chat', merged, { headers: {
                    'Content-Type': 'application/json',
                } });
            console.log('收到聊天回复:', response);
            // HTTP拦截器已经处理了响应，直接返回数据
            return response;
        }
        catch (error) {
            console.error('发送聊天消息失败:', error);
            throw error;
        }
    }
    /**
     * 处理用户选择的产品/风格
     */
    async selectStyle(text, productId) {
        const message = {
            text: '', // 使用空字符串，匹配 frontend/script.js 的行为
            ui_event: 'choose_vibe',
            ui_payload: {
                vibe_id: productId
            }
        };
        return this.sendMessage(message);
    }
    /**
     * 处理用户选择的产品/风格
     */
    async moodboardSend(text, productId) {
        const message = {
            text: '', // 使用空字符串，匹配 frontend/script.js 的行为
            ui_event: 'moodboard',
            ui_payload: {
                vibe_id: productId
            }
        };
        return this.sendMessage(message);
    }
    /**
     * 处理用户选择的产品/风格
     */
    async selectStyleOne(text) {
        const message = {
            text: text, // 使用空字符串，匹配 frontend/script.js 的行为
            ui_event: 'edit_vibe'
        };
        return this.sendMessage(message);
    }
    /**
     * 处理试穿请求
     */
    async tryOnOutfit(productId, clothingImageUrl) {
        const message = {
            text: '我想试穿这件衣服',
            ui_event: 'try_on_products',
            ui_payload: {
                product_id: productId,
                clothing_image_url: 'http://8.209.85.186:8002' + clothingImageUrl
            }
        };
        return this.sendMessage(message);
    }
    /**
     * 发送文本和图片消息
     */
    async sendTextAndImage(text, imageUrl) {
        const message = {
            text,
            image_url: imageUrl
        };
        return this.sendMessage(message);
    }
    /**
     * 发送文本和图片消息和选中图片
     */
    async sendTextAndImageCheck(text, imageUrl, thisImageUrl) {
        const message = {
            text,
            // image_url: imageUrl,
            image_url: thisImageUrl
        };
        return this.sendMessage(message);
    }
}
export default new ChatApi();
